import type { ExperimentConfig } from '@gem-sdk/experiment';

export const EXPERIMENT_CONFIG: ExperimentConfig = {
  experimentId: 'ab-testing',
  variants: [
    { name: 'A', weight: 0.5 },
    { name: 'B', weight: 0.5 },
  ],
};
